import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, ElementRef, forwardRef, Injector, OnInit, Optional, Self } from '@angular/core'
import { NG_VALUE_ACCESSOR, NgControl } from '@angular/forms'
import { CorpSpinnerComponent } from '@corporate-tailwind/component'
import { CorpControlTitleComponent } from '../common/corp-control-title/corp-control-title.component'
import { CorpControlCommonComponent } from '../common/corp-control-common/corp-control-common.component'

@Component({
    selector: 'corp-textarea',
    standalone: true,
    templateUrl: 'corp-textarea.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, CorpControlTitleComponent, CorpSpinnerComponent],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CorpTextareaComponent),
            multi: true,
        },
    ],
})
export class CorpTextareaComponent extends CorpControlCommonComponent implements OnInit {

    constructor(
        private injector: Injector,
        // private elementRef: ElementRef
        // @Self() @Optional() public ngControl: NgControl
    ) {
        super();
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }

    ngOnInit(): void {
        const ngControl = this.injector.get(NgControl, null)
        this.setNgControl(ngControl);
    }

}